import { useState } from "react";
import { toast } from "sonner";
import { PhoneInput } from "@/components/PhoneInput";
import { useAuth } from "@/context/AuthContext";
import { usePrefs } from "@/context/PrefsContext";
import { api, errMsg } from "@/lib/api";

export function PhoneSettings() {
  const { user, setUser } = useAuth();
  const { t } = usePrefs();
  const [v, setV] = useState({ country: user?.phone?.country || "+81", number: user?.phone?.number || "" });
  const [busy, setBusy] = useState(false);
  const save = async () => {
    setBusy(true);
    try { const { data } = await api.put("/profile/phone", { phone_country: v.country, phone_number: v.number }); setUser(data); toast.success(t("saved")); }
    catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <div className="soft-card mt-5 p-6" data-testid="phone-settings">
      <PhoneInput country={v.country} number={v.number} onChange={setV} testid="settings-phone" />
      <div className="mt-3 flex items-center justify-between gap-3">
        <span className="text-xs text-muted-foreground" data-testid="phone-current">{user?.phone?.e164 ? `${t("whatsappSaved")}: ${user.phone.e164}` : t("whatsappEmpty")}</span>
        <button data-testid="phone-save-button" disabled={busy || v.number.length < 8} onClick={save} className="rounded-full bg-foreground px-4 py-2 text-xs font-semibold text-background disabled:opacity-40">{t("save")}</button>
      </div>
    </div>
  );
}
